<p-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [showHeader]="false"
  [style]="{ width: '28rem' }"
  styleClass="bn-household-dialog">
  <div class="bn-household-header">
    <div class="min-w-0">
      <h2 class="bn-household-title" data-testid="household-title">Household members</h2>
      @if (!loading() && hasMembers()) {
        <p class="bn-household-subtitle" data-testid="household-subtitle">{{ membersOnFileLabel() }}</p>
      }
    </div>
    <button
      type="button"
      class="bn-household-close"
      data-testid="household-close"
      aria-label="Close"
      (click)="close()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="bn-household-body">
    @if (loading()) {
      <div class="flex flex-col gap-2" data-testid="household-loading">
        @for (i of [1, 2, 3]; track i) {
          <div class="flex flex-col gap-1.5 p-2.5 border border-surface-200 rounded-lg">
            <p-skeleton width="9rem" height="0.8125rem" />
            <p-skeleton width="5.5rem" height="0.625rem" />
            <p-skeleton width="100%" height="0.625rem" />
          </div>
        }
      </div>
    } @else if (hasMembers()) {
      <ul class="bn-household-list" data-testid="household-list">
        @for (member of members(); track member.guid) {
          <li
            class="bn-household-row"
            [class.bn-household-row-active]="isActiveSessionMember(member)"
            [class.bn-household-row-clickable]="isProfileClickable(member)"
            [attr.data-testid]="'household-row-' + member.guid"
            [attr.role]="isProfileClickable(member) ? 'button' : null"
            [attr.tabindex]="isProfileClickable(member) ? 0 : null"
            [attr.aria-disabled]="isActiveSessionMember(member) && !isProfileClickable(member) ? true : null"
            (click)="openMemberProfile(member)"
            (keydown.enter)="openMemberProfile(member)"
            (keydown.space)="$event.preventDefault(); openMemberProfile(member)">
            <div class="min-w-0 flex-1">
              <div class="flex items-center gap-2 min-w-0 flex-wrap">
                <span class="bn-household-name truncate">{{ member.firstName }} {{ member.lastName }}</span>
                <span class="bn-household-relationship" data-testid="household-relationship">{{
                  relationshipLabel(member)
                }}</span>
              </div>
              <div class="bn-household-dob" data-testid="household-dob">{{ dobDisplay(member) }}</div>
              <div class="bn-household-guid">
                <span
                  class="bn-household-guid-value font-mono truncate"
                  [attr.data-testid]="'household-guid-' + member.guid"
                  [attr.title]="member.guid"
                  >{{ member.guid }}</span
                >
                <button
                  type="button"
                  class="bn-household-guid-copy"
                  [attr.data-testid]="'household-guid-copy-' + member.guid"
                  pTooltip="Copy GUID"
                  tooltipPosition="top"
                  aria-label="Copy GUID"
                  (click)="copyGuid($event, member.guid)">
                  <i class="pi pi-copy"></i>
                </button>
              </div>
            </div>
          </li>
        }
      </ul>
    } @else {
      <div class="text-sm text-surface-600" data-testid="household-empty">No household members found.</div>
    }
  </div>
</p-dialog>

<bn-household-member-profile-modal
  [member]="profileMember()"
  [visible]="profileVisible()"
  (visibleChange)="onProfileVisibleChange($event)" />
